import nProgress from "nprogress";

nProgress.configure({
    showSpinner: false,
});

export const startLoading = () => {
    nProgress.start();
};

export const stopLoading = () => {
    nProgress.done();
};

/* 
Router.onRouteChangeStart = () => {
  NProgress.start();
};
123
Router.onRouteChangeComplete = () => {
  NProgress.done();
};

Router.onRouteChangeError = () => {
  // hanlde the rror
  NProgress.done();
}; */